import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('MainContainer')(
  css({
    mt: 'm',
  }),
);

themeStyles.addBaseStyles('TitleContainer')(
  css({
    mb: 'm',
    ml: '-14px',
    display: 'flex',
    maxHeight: '22px',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Title')(({ theme }) =>
  css({
    ml: '-8px',
    width: 'fit-content',
    color: theme.colors.blue,
    lineHeight: 'sm',
    textAlign: 'left',
    borderBottom: 'none',
    letterSpacing: '0.5px',
    '&:hover, &:focus': {
      borderBottom: 'none',
    },
  }),
);

themeStyles.addBaseStyles('ModalContentWrapper')(
  css({
    // subtracted px comes from header, disclaimer, ctas + margins
    maxHeight: ['calc(100svh - 236px)', 'calc(100vh - 332px)', '427px'],
    overflowY: 'scroll',
    overflowX: 'hidden',
    pb: 'm',
    mb: '14px',
    mr: '-17px', // this limits the width of the Modal title to 604px as per figma
  }),
);

themeStyles.addBaseStyles('ModalCardsWrapper')(
  css({
    mt: '30px',
    display: 'grid',
    gridTemplateColumns: ['repeat(1, auto)', 'repeat(1, auto)', 'repeat(2, 1fr)'],
    justifyContent: ['start', 'start', 'initial'],
    width: ['294px', '294px', 'auto'],
    gap: ['20px', '20px', 'm'],
  }),
);
export default themeStyles;
